"use strict";

var _classCallCheck = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var assert_1 = __importDefault(require("assert"));
/**
 * A mutex lock for coordination across async functions
 */
var AwaitLock = /*#__PURE__*/function () {
  function AwaitLock() {
    _classCallCheck(this, AwaitLock);
    this._acquired = false;
    this._waitingResolvers = [];
  }
  /**
   * Acquires the lock, waiting if necessary for it to become free if it is already locked. The
   * returned promise is fulfilled once the lock is acquired.
   *
   * After acquiring the lock, you **must** call `release` when you are done with it.
   */
  _createClass(AwaitLock, [{
    key: "acquireAsync",
    value: function acquireAsync() {
      var _this = this;
      if (!this._acquired) {
        this._acquired = true;
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        _this._waitingResolvers.push(resolve);
      });
    }
    /**
     * Acquires the lock if it is free and otherwise returns immediately without waiting. Returns
     * `true` if the lock was free and is now acquired, and `false` otherwise
     */
  }, {
    key: "tryAcquire",
    value: function tryAcquire() {
      if (!this._acquired) {
        this._acquired = true;
        return true;
      }
      return false;
    }
    /**
     * Releases the lock and gives it to the next waiting acquirer, if there is one. Each acquirer
     * must release the lock exactly once.
     */
  }, {
    key: "release",
    value: function release() {
      assert_1.default(this._acquired, 'Trying to release an unacquired lock');
      if (this._waitingResolvers.length > 0) {
        var resolve = this._waitingResolvers.shift();
        resolve();
      } else {
        this._acquired = false;
      }
    }
  }]);
  return AwaitLock;
}();
module.exports = AwaitLock;
module.exports.default = AwaitLock;
Object.defineProperty(module.exports, "__esModule", {
  value: true
});